import React from 'react';

/** X（原 Twitter）社媒图标，Figma 资源；fill 用 currentColor 以匹配 Footer .community 的灰/悬停主色 */
const Twitter = (props) => (
  <span {...props}>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0ZM14 0.875C6.75126 0.875 0.875 6.75126 0.875 14C0.875 21.2487 6.75126 27.125 14 27.125C21.2487 27.125 27.125 21.2487 27.125 14C27.125 6.75126 21.2487 0.875 14 0.875ZM14.8604 11.4736L18.7744 7H21.1494L15.9609 12.9307L22.0645 21H17.2852L13.542 16.1055L9.25879 21H6.88184L12.4316 14.6572L6.57617 7H11.4766L14.8604 11.4736ZM17.9404 19.5781H19.2568L10.7617 8.34668H9.34961L17.9404 19.5781Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export default Twitter;
